module.exports = __webpack_public_path__ + "img/icon_map_3_yj_c.7fa34f0a.png";